import React, { useState } from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import TextField from '@material-ui/core/TextField';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import OpenInNew from '@material-ui/icons/OpenInNew';
import DeleteForever from '@material-ui/icons/DeleteForever';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { formatDate } from '../../utils/common';
import { instanceAxios } from '../../InstanceAxios';
import DropZone from '../../components/DropZone';
import ListOfUsers from '../../components/ListOfUsers';
import { XMEI_PRIMARY_COLOR } from '../../consts/common';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 20,
  },
}));

function DocumentoUsuario() {
  const [abrirAlert, setAlert] = useState(false);
  const [mensagemAlert, setMensagemAlerta] = useState('');
  const [tipoAlerta, setTipoAlerta] = useState('success');
  const [idUsuario, setIdUsuario] = useState(0);
  const [colunasTabela] = useState([
    { id: 'descricao', label: 'Descrição', minWidth: 70 },
    { id: 'data_envio', label: 'Data Envio', minWidth: 140 },
    { id: 'responsavel_envio', label: 'Responsável Envio', minWidth: 140 },
    { id: 'abrir', label: '', minWidth: 140 },
    { id: 'apagar', label: '', minWidth: 140 },
  ]);
  const [nomeUsuario, setNomeUsuario] = useState('');
  const [modalAddFile, setModalAddFile] = useState(false);
  const [fileName, setFileName] = useState('');
  const [fileSelect, setFileSelect] = useState('');
  const [descricao, setDescricao] = useState('');
  const [arrayDocumentosUsuario, setArrayDocumentosUsuario] = useState([]);
  const [nomeUsuarioUpload, setNomeUsuarioUpload] = useState('');
  const [idUsuarioUpload, setIdUsuarioUpload] = useState('');
  const classes = useStyles();

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setAlert(false);
  };

  const fetchUserDocuments = async (id) => {
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/listarDocumentosUsuario/${id}`)
      .then((res) => {
        setArrayDocumentosUsuario(res.data.data);
      })
      .catch((err) => {});
  };

  const deleteUserDocument = async (idDocumento) => {
    await instanceAxios(localStorage.getItem('toobiauth'))
      .delete(`/apagarDocumentoUsuario/${idDocumento}`)
      .then((res) => {
        fetchUserDocuments(idUsuario);
        setAlert(true);
        setTipoAlerta('success');
        setMensagemAlerta('Documento deletado com sucesso.');
      })
      .catch((err) => {
        setAlert(true);
        setTipoAlerta('warning');
        setMensagemAlerta(
          'Houve um erro de comunicação, verifique sua conexão e tente novamente mais tarde.'
        );
      });
  };

  const uploadDocument = async () => {
    if (!fileSelect || !descricao || !nomeUsuarioUpload) {
      setAlert(true);
      setTipoAlerta('warning');
      setMensagemAlerta('Preencha todos os campos.');
    }
    const formData = new FormData();
    formData.append('file', fileSelect);
    formData.append('descricao', descricao);
    formData.append('id', idUsuarioUpload);
    formData.append('responsavel', 'XMEI');
    await instanceAxios(localStorage.getItem('toobiauth'))
      .post('/uploadDocumentoUsuario', formData)
      .then((res) => {
        setFileSelect('');
        setIdUsuarioUpload('');
        setNomeUsuarioUpload('');
        setDescricao('');
        setFileName('');
        setAlert(true);
        setTipoAlerta('success');
        setMensagemAlerta('Upload realizado com sucesso.');
      })
      .catch((err) => {
        setAlert(true);
        setTipoAlerta('warning');
        setMensagemAlerta(
          'Houve um erro de comunicação, verifique sua conexão e tente novamente mais tarde.'
        );
      });
  };

  const handleAddFile = () => {
    return (
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={modalAddFile}
        onClose={() => setModalAddFile(false)}
      >
        <div
          style={{
            backgroundColor: 'white',
            padding: 5,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <DropZone
            handleButtonClick={(file) => {
              setModalAddFile(false);
              if (file) {
                console.log(file[0]);
                setFileSelect(file[0]);
                setFileName(file[0].name);
              }
            }}
          />
        </div>
      </Modal>
    );
  };

  return (
    <div style={{ margin: 20 }}>
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap"
      />
      <Paper
        elevation={3}
        style={{
          marginBottom: 10,
          paddingTop: 20,
          paddingBottom: 20,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <h1
          style={{
            fontSize: 25,
            h1Align: 'center',
            fontWeight: 'bold',
            color: '#030d4f',
          }}
        >
          Documento do Usuário
        </h1>
      </Paper>
      <Paper
        elevation={3}
        className={classes.root}
        style={{ marginBottom: 10, paddingLeft: 30 }}
      >
        <p style={{ fontSize: '15px', paddingLeft: 8 }}>
          Buscar documentos do usuário
        </p>
        <ListOfUsers
          label="Nome do Cliente *"
          width="40%"
          userSelect={nomeUsuario}
          setUserSelect={(user) => setNomeUsuario(user)}
          setIdUsuario={(id) => {
            setIdUsuario(id);
            fetchUserDocuments(id);
          }}
        />
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {colunasTabela.map((column) => (
                  <TableCell key={column.id} align={column.align}>
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {arrayDocumentosUsuario.map((documento) => (
                <TableRow key={documento.id}>
                  <TableCell component="th" scope="row">
                    {documento.descricao}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {formatDate(documento.data_envio)}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {documento.responsavel_envio}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Button
                      size="small"
                      variant="contained"
                      color="primary"
                      onClick={() =>
                        window.open(documento.documento_path, '_blank')
                      }
                      startIcon={<OpenInNew />}
                    >
                      Abrir Documento
                    </Button>
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Button
                      size="small"
                      variant="contained"
                      color="secondary"
                      onClick={() => deleteUserDocument(documento.id)}
                      startIcon={<DeleteForever />}
                    >
                      Deletar
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <Paper
        elevation={3}
        className={classes.root}
        style={{ marginBottom: 10, paddingLeft: 30, marginTop: 10 }}
      >
        <p style={{ fontSize: '15px', fontWeight: 'normal' }}>
          Upload Documento do Usuário
        </p>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            marginTop: 10,
            marginBottom: 10,
          }}
        >
          <div
            style={{
              marginTop: 5,
              width: 'auto',
              marginRight: 15,
            }}
          >
            <p
              style={{
                fontSize: '13px',
                fontWeight: 'normal',
                marginBottom: 5,
              }}
            >
              Anexo
            </p>
            <Button
              startIcon={<CloudUploadIcon />}
              fullWidth
              size="small"
              variant="contained"
              style={{
                backgroundColor: XMEI_PRIMARY_COLOR,
                color: '#FFF',
              }}
              onClick={() => setModalAddFile(true)}
            >
              {fileName || 'Realizar Upload'}
            </Button>
          </div>
          <TextField
            id="standard-full-width"
            label="Descrição"
            style={{ margin: 8, width: '50%', marginTop: fileName ? 10 : 8 }}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(event) => {
              setDescricao(event.target.value);
            }}
            error={false}
            value={descricao}
          />
          <ListOfUsers
            label="Nome do Cliente *"
            width="40%"
            userSelect={nomeUsuarioUpload}
            setUserSelect={(user) => setNomeUsuarioUpload(user)}
            setIdUsuario={(id) => {
              setIdUsuarioUpload(id);
            }}
          />
        </div>
        {handleAddFile()}
      </Paper>
      <Snackbar open={abrirAlert} autoHideDuration={6000} onClose={handleClose}>
        <Alert severity={tipoAlerta} onClose={handleClose}>
          {mensagemAlert}
        </Alert>
      </Snackbar>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Button
          variant="contained"
          style={{
            backgroundColor: XMEI_PRIMARY_COLOR,
            color: '#FFF',
          }}
          onClick={() => uploadDocument()}
        >
          CADASTRAR
        </Button>
      </div>
    </div>
  );
}

export default DocumentoUsuario;
